import React from 'react';

import MemorySprkFilesItem from './SprkFilesItem';

import type { Asset } from '../../types/asset';

interface MemorySprkFilesProps {
  sharedAssets: Asset[];
  selectedAssets: string[];
  handleSelectFile: Function;
};

const MemorySprkFiles: React.FC<MemorySprkFilesProps> = ({ sharedAssets, selectedAssets, handleSelectFile }) => {
  return (
    <div className="memory-sprk-files-grid">
      {sharedAssets.map((asset) => (
        <MemorySprkFilesItem
          key={asset.id}
          asset={asset}
          isSelected={selectedAssets.includes(asset.id)}
          handleSelectFile={handleSelectFile}
        />
      ))}
    </div>
  );
}

export default MemorySprkFiles;
